export default __webpack_public_path__ + "static/media/rock-pillars.7f74ec4b.png";